/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  const role = currentUser?.access;
  const isOwner = role === 'owner';
  const isAdmin = role === 'admin';
  return {
    canAdmin: role === 'admin',
    canOwner: isOwner,
    /** 管理员及以上(Admin + Owner)可访问：监控台、信息收集 */
    canInfo: isAdmin || isOwner,
  };
}